<template>
  <section v-if="(results|| []).length > 0" class="section section-sm bg-transparent novi-background">
    <div class="container">
      <div class="col-sm-12 col-lg-12 m-0 p-0">
        <!-- Blurb-->
        <article class="blurb blurb-boxed p-2 text-center">
          <!--          <div class="blurb-embed"><span class="blurb-icon ith-layers novi-icon"></span></div>-->
          <!--          <div class="blurb-title h5">60+ reusable elements</div>-->
          <!--          <div class="blurb-text">Intense has a set of more than 60 UI elements designed to make your website attractive and feature-rich.</div>-->
          <template v-if="isQualified">
            <div class="blurb-title h5 text-center">Your Evaluation Results</div>
            <div class="blurb-text text-center">Please select your preferred option from below. We will be in contact with you for further assistance</div>
          </template>
          <template v-else>
            <div class="blurb-title h5 text-center" v-if="hasQualifiedResults">You may also apply for following programs with some improvements on your qualifications as noted below</div>
            <div class="blurb-text text-center" v-else>Your qualifications did not produce results. How ever you may apply for following with some improvements on your qualifications</div>
          </template>
        </article>
      </div>

      <div class="row row-30">
        <div class="col-sm-6 col-lg-4 program" v-for="res in (results || []).slice(0,3)" v-bind:key="res.code">
          <!-- Blurb modern-->
          <div class="pricing pricing-box bg-100" :class="{'pricing-box-accent-success' : selectedProgram === res}">
            <div class="pricing-box-header">
              <div class="pricing-box-label mb-2" v-if="selectedProgram === res">PREFERRED PROGRAM</div>
              <div>
                <img width="40" :src="'/images/countries/'+res.country_code+'.png'">
                <span class="pricing-box-title h6">{{ res.name }}</span>
              </div>
              <div class="pricing-box-divider"></div>
            </div>
            <div class="pricing-box-body">
              <div class="blurb-text">{{ res.description }}</div>
              <button v-if="res !== selectedProgram" class="btn btn-block btn-lg pricing-box-btn btn-primary" @click="selectProgram(res)">Select This</button>
<!--              <div class="pricing-box-links"><span>or</span><a class="pricing-box-link" href="#">See More Details</a></div>-->
            </div>
          </div>
        </div>
      </div>
      <!-- Snackbars-->
      <div class="col-md-6">
      </div>
    </div>

  </section>

</template>

<script>

import EoppService from "@/mixins/EoppService";

export default {
  name: 'ProgramList',
  components: {},
  mixins: [EoppService],
  data() {
    return {
    };
  },
  props: {
    isQualified: {type: Boolean, required: true},
    hasQualifiedResults: {type: Boolean, required: true},
    results: {type: Array, required: true},
    selectedProgram: {type: Object, required: false}
  },
  mounted() {
  },
  methods: {
    async selectProgram(prog) {
      let choice = await this.presentAlertConfirm('Confirm', 'Are you sure you want to change your preference');

      if ( choice ) {
        this.$emit('program', prog);
      }
    },
  }
}
</script>
<style>
.selected-program {
  /*width: 100%;*/
  font-size: x-large;
  color: white;
  background: #2c7;
  border-radius: 5px;
  padding: 4px;
}

.selected-program.icon {

}

@media (min-width: 768px) {
  .article-box-large {
    min-height: 22em;
  }

  .article-box-small {
    min-height: 15em;
  }
}
</style>
